// Arguments allow dependency inject making it easier to mock for testing
export function singleton<T, A extends unknown[]>(create: (...args: A) => T): (...args: A) => T {
    let instance: T
    return (...args: A) => {
        if (!instance) {
            instance = create(...args)
        }
        return instance
    }
}
